import styles from "./AppButton.module.scss";

import { PropsWithChildren } from "react";

import { AppLoadingIndicator } from "../AppLoadingIndicator/AppLoadingIndicator";

type AppButtonVariants =
  | "primary"
  | "critical"
  | "outlined"
  | "plain"
  | "surface"
  | "kendoPrimary";

interface AppButtonProps extends PropsWithChildren {
  variant?: AppButtonVariants;
  onClick?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
  type?: "button" | "submit" | "reset";
  "aria-pressed"?: boolean;
}

export const AppButton = ({
  variant = "primary",
  disabled = false,
  isLoading = false,
  onClick,
  children,
  className,
  type = "button",
  "aria-pressed": ariaPressed,
}: AppButtonProps) => {
  const baseClass = styles.button;
  const buttonVariant = styles[variant];
  const loadingClass = isLoading ? styles.isLoading : "";

  const buttonClasses = `${baseClass} ${buttonVariant} ${loadingClass} ${className}`;

  return (
    <button
      type={type}
      onClick={onClick}
      className={buttonClasses}
      disabled={disabled || isLoading}
      aria-pressed={ariaPressed}
    >
      <span className={styles.label}>{children}</span>
      {isLoading && (
        <div className={styles.loadingIndicator}>
          <AppLoadingIndicator size="small" />
        </div>
      )}
    </button>
  );
};
